<template>
  <router-view v-slot="{ Component }">
    <transition
      @enter="scrollTop"
      :name="transitionName"
      :mode="isDesktop ? undefined : 'out-in'"
    >
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script>
export default {
  computed: {
    transitionName() {
      return `slide${this.$route.meta.scrolling}`;
    }
  }
};
</script>

<route>
{
  "name": "Quanto sei Controcorrente?",
  "redirect": { "name": "Quanto controcorrente sei?" },
  "meta": {
      "flatten": true
  }
}
</route>
